module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "runners-list"
  }, [_vm._l((_vm.runners), function(runner) {
    return _c('li', {
      key: runner.id,
      staticClass: "runners-list__item"
    }, [_c('div', {
      staticClass: "flex"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "user-infos"
    }, [_c('h1', {
      staticClass: "name"
    }, [_vm._v("\n           " + _vm._s(runner.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "more-infos"
    }, [_c('div', {
      staticClass: "flex flex--align-start"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("secondsToHours")(runner.time)))]), _vm._v(" "), _c('span', {
      staticClass: "separation"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("distance")(runner.distance)))])])])])])])
  }), _vm._v(" "), (_vm.runners.length === 0) ? _c('li', {
    staticClass: "runners-list__item runners-list__item--empty"
  }, [_c('h1', [_vm._v("Don't have runners")])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-image"
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/thumb/men/10.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dead18a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Runners/RunnersResumeList.vue
// module id = 1826
// module chunks = 1